module.exports = __webpack_public_path__ + "static/media/summer.ac81bcb7.png";